// extracted by mini-css-extract-plugin
export var button = "_bj-0";
export var icon = "_bj-1";